import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class WishlistComponent extends Component {

  get SELECTORS() {
    return {
      container: '.js-wishlist-dropdown',
      main: '.js-wishlist',
      item: '.wishlist .product-item',
      sizeLayer: '.js-sizes',
      addedMsg: '.item-added',
      icon: '.action.wishlist',
      remove: '.js-remove-wish',
      emptyWish: '.js-empty-wishlist-msg',
      qty: '.qty-items',
      nav_wishlist: ".wishlist-nav",
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      active: 'active',
      removing: 'removing',
      icon_wishlist_on: "icon-wishlist-on",
      icon_wishlist_off: "icon-wishlist-off",
    };
  }

  constructor() {
    super();

    this.timeout = null;
    this.container = $(this.SELECTORS.container);
    this.main = $(this.SELECTORS.main);
    this.item = $(this.SELECTORS.item);
    this.sizeLayer = $(this.SELECTORS.sizeLayer);
    this.addedMsg = $(this.SELECTORS.addedMsg);
    this.icon = $(this.SELECTORS.icon);
    this.remove = $(this.SELECTORS.remove);
    this.updated = false;
    this.trackingComponent = new TrackingComponent();
  }


  openSizeLayer(el) {
    let code = $(el).data('baseCode');
    let $sizepanel = $(`li[data-code=${code}]`).find('.js-sizes');
    let $notifyme = $(`div[data-code=${code}]`);

    if ($sizepanel.length != 0) {
      $sizepanel.addClass(this.CLASSES.show);
      if (this.$matchMedia('sm', null)) this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark'});
      setTimeout(() => {
        $sizepanel.find('button').first().focus();
      }, 200);
    } else {
      $notifyme.addClass(this.CLASSES.show);
    }
  }

  closeSizeLayer() {
    this.main.find('.js-sizes').removeClass(this.CLASSES.show);
    if (this.$matchMedia('sm', null)) this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
  }

  openWishlist() {
    clearTimeout(this.timeout);
    const keyboard = document.querySelector('[data-whatinput="keyboard"]');
    const focusableContainer = document.querySelector(this.SELECTORS.container).querySelector('ul');
    const firstFocusable = this.$getFirstFocusable(focusableContainer);
    this.container.addClass(this.CLASSES.show);
    this.$emit(this.$customEvents.WISHLIST_EVENTS.enter, this.container);
    setTimeout(() => {
      firstFocusable.focus();
    }, 200);
    if (!keyboard) {
      this.timeout = setTimeout(() => {
        this.container.removeClass(this.CLASSES.show);
      }, 2000);
    }
  }

  appendHtml(html) {
    return new Promise((resolve, reject) => {
      try {
        this.main.html(html);
        resolve()
      } catch (e) {
        reject(e)
      }
    });
  }

  updateWishlist() {

    let ctx = this;
    let $elem = ctx.main;

    return $.ajax({
      url: $elem.data('href'),
      dataType: "html",
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }


  removeProduct(el) {

    let ctx = this;
    let $elem = $(el);
    let url = $elem.data('href');

    $.ajax({
      url: url,
      dataType: "json",
      type: 'POST',
      success: function () {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, el);
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });

  }

  showAddedMsg() {
    let ctx = this;
    ctx.main.find('.item-added').addClass(ctx.CLASSES.show);
    setTimeout(function () {
      ctx.main.find('.item-added').removeClass(ctx.CLASSES.show);
    }, 2000);
  }

  makeSizeActive(ev) {
    this.sizeLayer.find('.js-size-trigger').removeClass(this.CLASSES.active);
    $(ev.payload).addClass(this.CLASSES.active);
    this.log($(ev.payload).text());
  }

  showEmptyMsg($el) {
    let $layer = $el.find('.layer-body');
    let $footer = $el.find('footer');
    let $icon = this.container.find('.qty-icon');
    let msg = $layer.data('empty-msg');

    $layer.addClass('empty-body').html(`<p>${msg}</p>`);
    $footer.fadeOut();
    $icon.fadeOut();
    $(this.SELECTORS.emptyWish).addClass(this.CLASSES.show)
  }

  desktopBehaviour() {
    this.$on('mouseenter.wishlist', ({event}) => {
      clearTimeout(this.timeout);
      //update wishlist only on the first over
      this.firstUpdate(event, 'lg');
      this.$emit(this.$customEvents.WISHLIST_EVENTS.enter, this.container);
    }, 'body', `${this.SELECTORS.main}, ${this.SELECTORS.container}`);

    this.$on('mouseleave.wishlist', ({event}) => {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
        source: event.currentTarget,
        res: 'lg'
      });
      this.$emit(this.$customEvents.WISHLIST_EVENTS.exit);
    }, 'body', `${this.SELECTORS.main}, ${this.SELECTORS.container}`);

    this.$on('keyup.wishlist', ({event}) => {
      if (event.which === 13) {
        const firstFocusable = this.$getFirstFocusable(event.currentTarget);
        this.firstUpdate(event, 'md');
        setTimeout(() => {
          firstFocusable.focus();
        }, 200)
      }
    }, 'body', this.SELECTORS.container);

  }

  tabletBehaviour() {
    this.$on('click.wishilist', ({event}) => {
      this.firstUpdate(event, 'md')
    }, 'body', `${this.SELECTORS.container} .dropdown-toggle`);
  }

  mobileBehaviour() {
    this.$on('click.wishilist', ({event}) => {
      this.firstUpdate(event, 'sm')
    }, 'body', `${this.SELECTORS.container} .dropdown-toggle`);
  }

  firstUpdate(event, br) {
    if (!this.updated) {
      this.updateWishlist().then(res => {
        this.appendHtml(res).then(res => {
          //console.log('Miniwishlist updated...');
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
            source: event.currentTarget,
            res: br
          });
          this.updated = true;
          this.$emit(this.$customEvents.WISHLIST_EVENTS.update, this.container);
        });
      });
    } else {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
        source: event.currentTarget,
        res: br
      });
    }
  }


  bindEvents() {

    let ctx = this;

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      if ($(e.payload).data('from-wishlist')) {
        this.openSizeLayer(e.payload);
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {

      //Remove from miniwishlist when selecting a size in miniwishlist
      let fromMiniWislist = $(payload.button).data('from-wishlist');
      if (fromMiniWislist) {
        //$(payload.button).closest('.product-item').find('.js-remove-wish').trigger('click');
        ctx.showAddedMsg();
      }

    });


    this.$on(this.$customEvents.PRODUCT_EVENTS.addtowish, (e) => {

      let $elem = $(e.payload);
      let url = $elem.data('href');
      this.originalFocus = e.payload;

      this.trackingComponent.actions.wishlist($elem.data());

      $.ajax({
        url: url,
        data: {
          code: $elem.data('code')
        },
        dataType: "html",
        success: function (resp) {
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, $elem);
          let qty = resp;
          $(ctx.SELECTORS.qty).text(qty);

          if (qty > 0) {
            let nav_wishlist = document.querySelector(ctx.SELECTORS.nav_wishlist);
            nav_wishlist.classList.remove(ctx.CLASSES.icon_wishlist_off);
            nav_wishlist.classList.add(ctx.CLASSES.icon_wishlist_on);
          }
        },
        error: function (xhr) {
          console.log('error in add to wishlist');
        }
      });

    });


    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, () => {
      this.updateWishlist().then(res => {
        this.appendHtml(res).then(res => {
          if (this.$matchMedia(null, 'sm')) {
            this.openWishlist();
          }
        });
      });
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, (e) => {
      this.updateWishlist().then(res => {
        this.appendHtml(res).then(res => {

          let ctx = this;
          let $elem = $(e.payload);
          let code = $elem.data('code');
          let $main = $elem.closest(ctx.SELECTORS.main);
          let item = $(`li[data-code="${code}"]`);
          let qty;

          if (document.querySelector('.layer-body.empty-body') != null) {
            qty = 0;
          } else {
            qty = parseInt(document.querySelector(ctx.SELECTORS.qty).innerHTML);

            $(ctx.SELECTORS.qty).text(qty);

            if (qty > 0) {
              ctx.container.find('.qty-icon').text(qty);
            }
          }

          if (qty === 0) {
            let nav_wishlist = document.querySelector(ctx.SELECTORS.nav_wishlist);

            setTimeout(() => {
              ctx.showEmptyMsg($main);
            }, 400);
            nav_wishlist.classList.remove(ctx.CLASSES.icon_wishlist_on);
            nav_wishlist.classList.add(ctx.CLASSES.icon_wishlist_off);
          }

          item.addClass(ctx.CLASSES.removing);

          setTimeout(function () {
            item.remove()
          }, 800);

        });
      });
    });

    $('body').off('click.wishlist').on('click.wishlist', ctx.SELECTORS.remove, function () {
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, this)
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwish, (e) => {
      this.removeProduct(e.payload);
    });


    if (this.$matchMedia(null, 'lg')) {
      this.desktopBehaviour();
    } else if (this.$matchMedia('lg', 'sm')) {
      this.tabletBehaviour();
    } else {
      this.mobileBehaviour()
    }

    window.addEventListener('resize', () => {
      if (this.$matchMedia(null, 'lg')) {
        this.desktopBehaviour();
      }/* else if (this.$matchMedia('lg', 'sm')) {
        this.tabletBehaviour();
      } else {
        this.mobileBehaviour()
      }*/
    });


  }

  render() {
    this.bindEvents();
  }
}
